import { PurchaseDocument } from '../models'
import { getProjectUnit } from './project-helpers'

export const getPurchaseDocumentBuyer = (document: PurchaseDocument): string => {
  return {
    individual: document.user_individual_name,
    business: document.buyer_company
  }[document.user_type] || '-'
}

export const getFilteredDocuments = (text: string, documents: PurchaseDocument[]): PurchaseDocument[] => {
  let newDocuments: PurchaseDocument[] = documents

  // Filter By Text
  if (text) {
    const searchText = text?.toLowerCase()
    newDocuments = newDocuments.filter((document: PurchaseDocument)=> {
      return (
        getPurchaseDocumentBuyer(document).toLowerCase().includes(searchText) ||
        document.project_name.toLowerCase().includes(searchText) ||
        document.project_name.toLowerCase().includes(searchText) ||
        document?.user_individual_name?.toLowerCase().includes(searchText) ||
        `${document.amount}`?.toLowerCase().includes(searchText) ||
        `${document.total}`?.toLowerCase().includes(searchText) ||
        getProjectUnit(document.project_kind)?.toLowerCase().includes(searchText) ||
        `${document.currency}`?.toLowerCase().includes(searchText)
      )
    })
  }
  return newDocuments
}
export const getProjectKindLabel = (kind: string) => {
  switch (kind) {
    case 'carbon_forward': return 'Carbon Forward'
    case 'contribution': return 'Contribution'
    case 'compensation': return 'Compensation'
    case 'biodiversity': return 'Biodiversity'
    case 'energy': return 'Renowable Energy'
  }
}
